function TeamMemberIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" rx="12" fill="#FBB414" />
            <path
                d="M15.5556 12C17.0283 12 18.2222 10.8061 18.2222 9.33333C18.2222 7.86057 17.0283 6.66667 15.5556 6.66667C14.0828 6.66667 12.8889 7.86057 12.8889 9.33333C12.8889 10.8061 14.0828 12 15.5556 12Z"
                fill="white"
            />
            <path
                d="M8.44444 9.33333C9.9172 9.33333 11.1111 8.13943 11.1111 6.66667C11.1111 5.19391 9.9172 4 8.44444 4C6.97169 4 5.77778 5.19391 5.77778 6.66667C5.77778 8.13943 6.97169 9.33333 8.44444 9.33333Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.1111 14.6667C11.1111 13.6844 11.8996 12.8889 12.8889 12.8889H18.2222C19.2044 12.8889 20 13.6756 20 14.6667V17.9822C20 20.6729 11.1111 20.6729 11.1111 17.9822V14.6667Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.8889 12C12.8892 11.7664 12.8435 11.5351 12.7543 11.3193C12.6651 11.1034 12.5341 10.9073 12.369 10.7421C12.2038 10.577 12.0077 10.4461 11.7919 10.3568C11.576 10.2676 11.3447 10.2219 11.1111 10.2222H5.77778C4.78844 10.2222 4 11.0196 4 12.0027V15.4036C4 17.1111 7.60356 17.6418 10.2222 17.1671V14.672C10.2216 14.3216 10.2901 13.9746 10.4237 13.6506C10.5572 13.3267 10.7533 13.0323 11.0007 12.7841C11.2481 12.536 11.5419 12.339 11.8655 12.2045C12.189 12.07 12.5358 12.0005 12.8862 12H12.8889Z"
                fill="white"
            />
        </svg>
    );
}

export default TeamMemberIcon;
